import {useRouter} from 'next/router'
import Loader from '../Loader'

export default function PersonalizeLoader() {
  const router = useRouter()
  const name =
    router.query.name != undefined ? (router.query.name as string) : ''
  return (
    <>
      <Loader />
      <p className="text-primary text-center mt-4">{name} بناء قصتك</p>
    </>
  )
}
